<template>
  <div>
    <v-stepper v-model="stepProxy" alt-labels flat non-linear>
      <v-stepper-header>
        <v-stepper-step
          :complete="stepProxy > 1"
          editable
          step="1"
          :color="stepOneError ? 'red' : 'primary'"
          :edit-icon="stepOneError ? 'mdi-alert' : '$edit'"
        >
          <span :class="stepOneError ? 'red--text' : ''">Infos générales</span>
        </v-stepper-step>
        <v-divider></v-divider>
        <v-stepper-step
          :complete="stepProxy > 2"
          editable
          step="2"
          :color="stepTwoError ? 'red' : 'primary'"
          :edit-icon="stepTwoError ? 'mdi-alert' : '$edit'"
        >
          <span :class="stepTwoError ? 'red--text' : ''">
            Modèles de cartes</span
          >
        </v-stepper-step>
        <v-divider></v-divider>
        <v-stepper-step step="3"> Résumé </v-stepper-step>
      </v-stepper-header>
      <v-stepper-items>
        <v-stepper-content step="1" class="pa-0">
          <v-card class="pa-0" flat>
            <v-card-text class="pa-0">
              <v-row>
                <v-col cols="12">
                  <v-select
                    :rules="rules.partnerRules"
                    item-value="id"
                    item-text="name"
                    label="Partenaire"
                    :items="partners"
                    v-model="formProxy.partner"
                    :loading="isLoading"
                  ></v-select>
                </v-col>
                <v-col cols="12" class="pt-0">
                  <v-autocomplete
                    v-model="formProxy.clientPortal"
                    item-value="id"
                    item-text="description"
                    :items="portals"
                    :loading="loadingPortals"
                    :search-input.sync="portalSearch"
                    label="Client"
                    :no-data-text="
                      portalSearch
                        ? 'Aucun portail ne correspond à la recherche'
                        : 'Veuillez renseigner un nom de portail'
                    "
                    :rules="rules.clientRules"
                  ></v-autocomplete>
                </v-col>
                <v-col cols="12" class="pt-0">
                  <v-text-field
                    v-model="formProxy.prefix"
                    label="Préfixe"
                    :rules="rules.prefixRules"
                    :loading="fetchingPortal"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" class="pt-0">
                  <v-textarea
                    v-model="formProxy.comment"
                    label="Commentaire"
                    :rules="rules.commentRules"
                  ></v-textarea>
                </v-col>
                <v-col cols="12" class="pt-0">
                  <v-card flat>
                    <v-card-title
                      class="pb-1 px-1 text-body-1 font-weight-medium"
                    >
                      Envoi d'une notification
                      <v-spacer></v-spacer>
                      <v-radio-group
                        v-model="formProxy.notification"
                        row
                        hide-details
                        class="mt-0 pt-0"
                      >
                        <v-radio :value="1" label="Oui"></v-radio>
                        <v-radio :value="0" label="Non"></v-radio>
                      </v-radio-group>
                    </v-card-title>
                  </v-card>
                </v-col>
              </v-row>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions class="px-0">
              <v-spacer></v-spacer>
              <v-btn
                color="primary"
                @click="stepProxy = 2"
                :disabled="fetchingPortal"
              >
                Continuer
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-stepper-content>
        <v-stepper-content step="2" class="pa-0">
          <v-card flat class="pa-0">
            <v-card-text class="pa-0">
              <v-row>
                <v-col cols="12">
                  <v-btn block @click="addCardModelEdition">
                    Ajouter un modèle de carte
                  </v-btn>
                </v-col>
                <v-col cols="12">
                  <div v-for="(model, index) in modelsArray" :key="index">
                    <v-card outlined class="mb-2">
                      <v-card-title>
                        <span>Modèle #{{ index + 1 }}</span>
                        <v-spacer></v-spacer>
                        <v-btn
                          color="red"
                          icon
                          @click="deleteCardModelFromEdition(index)"
                        >
                          <v-icon>mdi-delete</v-icon>
                        </v-btn>
                      </v-card-title>
                      <v-divider></v-divider>
                      <v-card-text>
                        <v-row>
                          <v-col cols="12" md="6" class="pt-0">
                            <v-text-field
                              type="number"
                              v-model.number="model.sessionsNumber"
                              label="Nombre de sessions"
                              hide-details
                            ></v-text-field>
                          </v-col>
                          <v-col cols="12" md="6" class="pt-0">
                            <v-text-field
                              type="number"
                              v-model.number="model.cardNumber"
                              label="Nombre de cartes"
                              hide-details
                            ></v-text-field>
                          </v-col>
                          <v-col cols="12" class="pt-0">
                            <v-select
                              label="Type de restriction"
                              :items="restrictions"
                              v-model="model.restrictionType"
                              hide-details
                            ></v-select>
                          </v-col>
                          <v-col cols="12" class="pt-0">
                            <v-card flat class="pa-0">
                              <v-card-title
                                class="pb-1 px-1 text-body-1 font-weight-medium"
                              >
                                Mode
                                <v-spacer></v-spacer>
                                <v-radio-group
                                  v-model="model.mode"
                                  row
                                  hide-details
                                  class="mt-0 pt-0"
                                >
                                  <v-radio :value="0" label="Basic"></v-radio>
                                  <v-radio :value="1" label="Full"></v-radio>
                                </v-radio-group>
                              </v-card-title>
                            </v-card>
                            <v-divider></v-divider>
                          </v-col>
                          <v-col cols="12" class="pt-0">
                            <v-card flat>
                              <v-card-title
                                class="pb-1 px-1 text-body-1 font-weight-medium"
                              >
                                Type de carte
                                <v-spacer></v-spacer>
                                <v-radio-group
                                  v-model="model.cardType"
                                  row
                                  hide-details
                                  class="mt-0 pt-0"
                                >
                                  <v-radio
                                    :value="1"
                                    label="Décompte"
                                  ></v-radio>
                                  <v-radio :value="2" label="Temps"></v-radio>
                                </v-radio-group>
                              </v-card-title>
                            </v-card>
                            <v-divider></v-divider>
                          </v-col>
                          <v-col cols="12" class="pt-0">
                            <v-row>
                              <v-col cols="6" cmass="pa-0">
                                <v-text-field
                                  type="number"
                                  label="Durée"
                                  v-model.number="model.durationInput"
                                ></v-text-field>
                              </v-col>
                              <v-col cols="6" cmass="pa-0">
                                <v-select
                                  label="Unité"
                                  v-model.number="model.durationUnit"
                                  :items="durationUnits"
                                ></v-select>
                              </v-col>
                            </v-row>
                          </v-col>
                        </v-row>
                      </v-card-text>
                    </v-card>
                  </div>
                </v-col>
              </v-row>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions class="px-0">
              <v-spacer></v-spacer>
              <v-btn color="primary" text @click="stepProxy = 1">
                Retour
              </v-btn>
              <v-btn
                color="primary"
                @click="stepProxy = 3"
                :disabled="modelsArray.length < 1"
              >
                Continuer
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-stepper-content>
        <v-stepper-content step="3" class="pa-0">
          <div v-if="stepProxy == 3">
            <v-card outlined class="mb-2">
              <v-simple-table>
                <template v-slot:default>
                  <tbody>
                    <tr>
                      <td class="font-weight-bold">Commentaire</td>
                      <td>{{ formProxy.comment }}</td>
                    </tr>
                    <tr>
                      <td class="font-weight-bold">Partenaire</td>
                      <td>
                        <span v-if="!fetchingPartner">{{
                          getPartnerNameFromId(formProxy.partner)
                        }}</span>
                        <v-progress-circular
                          v-else
                          size="20"
                        ></v-progress-circular>
                      </td>
                    </tr>
                    <tr>
                      <td class="font-weight-bold">Client</td>
                      <td>
                        <span v-if="!fetchingPortal">{{
                          getPortalNameFromId(formProxy.clientPortal)
                        }}</span>
                        <v-progress-circular
                          v-else
                          size="20"
                        ></v-progress-circular>
                      </td>
                    </tr>
                    <tr>
                      <td class="font-weight-bold">Préfixe</td>
                      <td>{{ formProxy.prefix }}</td>
                    </tr>
                    <tr>
                      <td class="font-weight-bold">Envoi d'une notification</td>
                      <td>
                        <span v-if="formProxy.notification == 0">Non</span>
                        <span v-else-if="formProxy.notification == 1">Oui</span>
                      </td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </v-card>
            <v-card outlined>
              <v-expansion-panels accordion hover>
                <v-expansion-panel
                  v-for="(model, indexResume) in modelsArray"
                  :key="indexResume"
                >
                  <v-expansion-panel-header>
                    Modèle #{{ indexResume + 1 }}
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <v-simple-table>
                      <template v-slot:default>
                        <tbody>
                          <tr>
                            <td class="font-weight-bold">Nb cartes à éditer</td>
                            <td>{{ model.cardNumber }}</td>
                          </tr>
                          <tr>
                            <td class="font-weight-bold">Durée</td>
                            <td>{{ getStringDuration(model) }}</td>
                          </tr>
                          <tr>
                            <td class="font-weight-bold">Nb sessions</td>
                            <td>{{ model.sessionsNumber }}</td>
                          </tr>
                          <tr>
                            <td class="font-weight-bold">Restrictions</td>
                            <td>
                              {{
                                getRestrictionTextFromValue(
                                  model.restrictionType
                                )
                              }}
                            </td>
                          </tr>
                          <tr>
                            <td class="font-weight-bold">Type de carte</td>
                            <td>
                              <span v-if="model.cardType == 1">Décompte</span>
                              <span v-else-if="model.cardType == 2">Temps</span>
                            </td>
                          </tr>
                          <tr>
                            <td class="font-weight-bold">Mode</td>
                            <td>
                              <span v-if="model.mode == 0">Basic</span>
                              <span v-else-if="model.mode == 1">Full</span>
                            </td>
                          </tr>
                        </tbody>
                      </template>
                    </v-simple-table>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>
            </v-card>
          </div>
        </v-stepper-content>
      </v-stepper-items>
    </v-stepper>
  </div>
</template>
<script>
import {
  defineComponent,
  computed,
  onMounted,
  toRefs,
  ref,
  onUnmounted,
  watch,
} from "@vue/composition-api";
import { usePartner } from "@/composables/partner";
import { useClientPortal } from "@/composables/client-portal";

export default defineComponent({
  props: {
    form: Object,
    rules: Object,
    step: Number,
    restrictions: Array,
    stepOneError: Boolean,
    stepTwoError: Boolean,
  },
  setup(props, { emit }) {
    /* Import des API */
    const { listPartners, partnerData, showPartner } = usePartner();
    const {
      listClientPortals,
      data,
      criteriaClientPortal,
      showClientPortal,
      currentClientPortal,
    } = useClientPortal();

    /* Variables */
    const loadingPortals = ref(false);
    const portalSearch = ref("");
    const portalTimerId = ref(0);
    const debounceInterval = 500;
    const durationUnits = [
      { text: "An(s)", value: 32140800 },
      { text: "Mois", value: 2678400 },
      { text: "Semaine(s)", value: 7 * 24 * 60 * 60 },
      { text: "Jour(s)", value: 24 * 60 * 60 },
      { text: "Heure(s)", value: 60 * 60 },
      { text: "Minutes", value: 60 },
    ];
    const modelsArray = ref([]);
    const fetchingPortal = ref(false);
    const fetchingPartner = ref(false);

    /* Computed */
    const formProxy = computed({
      get: function () {
        return props.form;
      },
      set: function (value) {
        emit("update:form", value);
      },
    });
    const stepProxy = computed({
      get: function () {
        return props.step;
      },
      set: function (value) {
        emit("update:step", value);
      },
    });
    const portals = computed(function () {
      return data.clientPortals.data;
    });

    /* Méthodes */
    const fetchPortals = async function () {
      loadingPortals.value = true;
      await listClientPortals(null, portalSearch.value);
      loadingPortals.value = false;
    };
    const addCardModelEdition = function () {
      modelsArray.value.push({});
      formProxy.value.cardModels = modelsArray.value;
    };
    const deleteCardModelFromEdition = function (index) {
      modelsArray.value.splice(index, 1);
      formProxy.value.cardModels = modelsArray.value;
    };
    const getStringDuration = function (model) {
      const durationUnit = durationUnits.filter(
        (x) => x.value == model.durationUnit
      )[0];
      if (durationUnit) {
        if (parseInt(model.durationInput) > 1) {
          return `${model.durationInput} ${durationUnit.text.replace(
            "(s)",
            "s"
          )}`;
        } else {
          return `${model.durationInput} ${durationUnit.text.replace(
            "(s)",
            ""
          )}`;
        }
      } else {
        return "-";
      }
    };
    const getPortalNameFromId = function (id) {
      if (id == currentClientPortal.value.id) {
        return currentClientPortal.value.description;
      } else {
        return "-";
      }
    };
    const getPartnerNameFromId = function (id) {
      if (id == partnerData.partner.id) {
        return partnerData.partner.name;
      } else {
        return "-";
      }
    };
    const getRestrictionTextFromValue = function (value) {
      const restriction = props.restrictions.filter((x) => x.value == value)[0];
      if (restriction) {
        return restriction.text;
      } else {
        return "-";
      }
    };

    /* Cycle de vie */
    onMounted(async () => {
      formProxy.value.notification = 0;
      await listPartners();
    });
    onUnmounted(() => {
      criteriaClientPortal.value.description = "";
    });

    /* Watchers */
    watch(
      () => portalSearch.value,
      (newValue) => {
        if (newValue) {
          criteriaClientPortal.value.description = newValue;
          clearTimeout(portalTimerId.value);
          portalTimerId.value = setTimeout(() => {
            fetchPortals();
          }, debounceInterval);
        }
      }
    );
    watch(
      () => formProxy.value.clientPortal,
      async (newValue) => {
        if (newValue) {
          fetchingPortal.value = true;
          await showClientPortal(newValue);
          fetchingPortal.value = false;
          formProxy.value.prefix = currentClientPortal.value.cardPrefix;
        }
      }
    );
    watch(
      () => formProxy.value.partner,
      async (newValue) => {
        if (newValue) {
          fetchingPartner.value = true;
          await showPartner(newValue);
          fetchingPartner.value = false;
        }
      }
    );
    watch(
      () => props.stepOneError,
      (newValue, oldValue) => {
        if (newValue && !oldValue) {
          stepProxy.value = 1;
        }
      }
    );
    watch(
      () => props.stepTwoError,
      (newValue, oldValue) => {
        if (newValue && !oldValue) {
          stepProxy.value = 2;
        }
      }
    );

    return {
      formProxy,
      stepProxy,
      ...toRefs(partnerData),
      loadingPortals,
      criteriaClientPortal,
      portals,
      portalSearch,
      addCardModelEdition,
      durationUnits,
      deleteCardModelFromEdition,
      modelsArray,
      getStringDuration,
      getPortalNameFromId,
      getPartnerNameFromId,
      getRestrictionTextFromValue,
      fetchingPortal,
      fetchingPartner,
    };
  },
});
</script>
